import React from "react";
import {DutyManagerReport} from "../../../../../../../api/grs";
import ReportFormDetails from "./Details/ReportFormDetails";
import DutyManagerFormDetails from "./DutyManagerFormDetails";
import VehicleSection from "./Vehicle/VehicleSection";

const DutyManagerReportInsert = (props: DutyManagerReport) => {
    return (
        <React.Fragment>
            <ReportFormDetails {...props} />
            <VehicleSection {...JSON.parse(props.payload)} />
            <DutyManagerFormDetails {...JSON.parse(props.payload)} />
        </React.Fragment>
    );
};

export default DutyManagerReportInsert;
